import { facilityQueryKeys } from "@gymflow/api";
import { FacilityDTO } from "@gymflow/types";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { noPagination } from "libs/helpers/src/lib/pagination/noPagination";

import useGymflowModels from "../../../../../store";
import { FormSelectInput, FormSelectInputProps } from "../FormSelectInput";

type FormSelectFacilityCategoryProps<T> = Omit<
  FormSelectInputProps<T, FacilityDTO>,
  "dataFetchingQuery"
>;

export const FormSelectFacilityCategory = <T,>({
  ...props
}: FormSelectFacilityCategoryProps<T>) => {
  const { api } = useGymflowModels();
  return (
    <FormSelectInput
      {...props}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: facilityQueryKeys.list(),
          queryFn: async () => (await api.facilityApi.fetchCategories()).data,
          select: (data) => ({
            pageParams: data.pageParams,
            pages: data.pages.map((page) =>
              page.map((value) => ({
                id: value.id,
                label: value.name,
                value: value,
              })),
            ),
          }),
          ...noPagination,
        })
      }
    />
  );
};
